import FileIcon from "@/assets/svgs/file-icon";
import StudyMaterialIcon from "@/assets/svgs/study-material-icon";
import React from "react";
import { Pressable, View, Text } from "react-native";
import { SheetIds } from "../utils/sheet-ids";
import {
  DownloadStudyMaterialSheetPayload,
  DownloadStudyMaterialSheetResult,
} from "../sheets/download-study-material-sheet";
import { useSheet } from "../shared/sheet-provider";
import { Id } from "@teachloop/backend/_generated/dataModel";

function StudyMaterialList({
  files,
}: {
  files: { storageId: Id<"_storage">; url: string | null; fileName: string }[];
}) {
  const { open: openDownloadStudyMaterialSheet } = useSheet<
    DownloadStudyMaterialSheetPayload,
    DownloadStudyMaterialSheetResult
  >(SheetIds.DOWNLOAD_STUDY_MATERIAL_SHEET);

  return (
    <View className="gap-4">
      <View className="flex-row gap-2">
        <StudyMaterialIcon className="size-6" pathClassName="stroke-gray-800" />
        <Text className="text-base font-geologica-medium font-medium text-gray-800">
          Study material
        </Text>
      </View>
      <View className="gap-2">
        {files.map((file) => (
          <Pressable
            key={file.storageId}
            className="flex-row gap-2 items-center"
            disabled={!file.url}
            onPress={() => {
              if (file.url) {
                openDownloadStudyMaterialSheet({
                  fileName: file.fileName,
                  url: file.url,
                });
              }
            }}
          >
            <FileIcon
              className="size-4"
              pathClassName="stroke-teachLoop-accentPrimary"
            />
            <Text className="text-base font-geologica-medium text-teal-600">
              {file.fileName}
            </Text>
          </Pressable>
        ))}

        {files.length === 0 && (
          <Text className="text-base font-geologica-regular text-teachLoop-textPrimary">
            No study material provided
          </Text>
        )}
      </View>
    </View>
  );
}

export default StudyMaterialList;
